import { Injectable } from '@angular/core';
import { INDRAApiService } from '@ibe.services/api.indra.service';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { MOCK_STATUS, MOCK_URL_MILES_CONVERSION_RATE, URL_MILES_CONVERSION_RATE, URL_MILES_USE_MILES, URL_ADD_MILES_DISCOUNT, URL_REMOVE_MILES_DISCOUNT,  } from '@ibe.config';

@Injectable({
	providedIn: 'root'
})
export class INDRAMilesService {

	flightDetails: Array<any> = [];
	conversionRates: Array<any> = [];
	conversionRates$: BehaviorSubject<Array<any>> = new BehaviorSubject([]);

  	private _triggerUseMiles = new BehaviorSubject<boolean>(false);
  	triggerUseMiles$ = this._triggerUseMiles.asObservable();

	public oldMilesValue: any;

	constructor(private api: INDRAApiService, private http: HttpClient) {

	}


	public INDRA_getMilesConversionRates() {
		let apiRequest;
		if (MOCK_STATUS.MILES_CONVERSION_RATE) {
			apiRequest = this.http.get<any>(MOCK_URL_MILES_CONVERSION_RATE);
		} else {
			apiRequest = this.api.INDRA_get<any>(URL_MILES_CONVERSION_RATE);
		}

		apiRequest.subscribe(response => {
			if (response && response.status === '200' && response.conversionRates && response.conversionRates.length) {
				this.conversionRates = response.conversionRates;
				this.conversionRates$.next(response.conversionRates);
			} else {
				this.conversionRates = [];
				this.conversionRates$.next([]);
			}
		});
	}

	public INDRA_convertToMiles(cash: number) {
		const currencyRatio = this.conversionRates[this.conversionRates.length - 1].currencyRatio;
		const ruleRatio = this.conversionRates[this.conversionRates.length - 1].ruleRatio;
		const miles = cash * (currencyRatio * ruleRatio);
		return parseFloat(miles.toFixed(0));
	}

	public INDRA_convertToCash(miles: number) {
		const currencyRatio = this.conversionRates[this.conversionRates.length - 1].currencyRatio;
		const ruleRatio = this.conversionRates[this.conversionRates.length - 1].ruleRatio;
		const cash = miles / (currencyRatio * ruleRatio);
		return parseFloat(cash.toFixed(2));
	}

	public INDRA_getMaxConversion(cashToBePaid: number, userMiles: number) {
		let maxConversion: number = 0;
		let maxConvertedCash: number = 0;
		if (this.INDRA_convertToCash(userMiles) > cashToBePaid || !userMiles) {
			maxConversion = this.INDRA_convertToMiles(cashToBePaid);
			maxConvertedCash = cashToBePaid;
		} else {
			maxConversion = userMiles;
			maxConvertedCash = this.INDRA_convertToCash(userMiles);
		}

		return { maxConversion, maxConvertedCash };
	}

	public INDRA_convertSelectedPriceFromFlight(cashToBePaid: number, cashToConvert: number) {
		let convertedPrice: number = 0;

		// get percentage of selected price from total flight price
		const limit = parseFloat(((+cashToConvert / cashToBePaid) * 100).toFixed(0));

		if (limit) {
			// get applicable conversion rate
			let currencyRatio = 0;
			let ruleRatio = 0;
			const conversionRate = this.conversionRates;
			if (conversionRate.length && limit >= conversionRate[0].minLimit ) {
				conversionRate.forEach(rate => {
					if (limit >= rate.minLimit) {
						ruleRatio = rate.ruleRatio;
						currencyRatio = rate.currencyRatio;
					}
				});

				if (!currencyRatio) {
					currencyRatio = conversionRate[0].currencyRatio;
				}

				if (!ruleRatio) {
					ruleRatio = conversionRate[0].finalRaiot;
				}
			}

			if (currencyRatio && ruleRatio) {
				// convert selected price based on currency ratio
				convertedPrice = cashToConvert * (currencyRatio * ruleRatio);
			}
		}

		return parseFloat(convertedPrice.toFixed(0));
	}

	// not used
	public INDRA_calculateNewPriceToBePaid(cashToBePaid: number, priceToConvert: number): number {
		let newCashTobePaid: number = 0;

		// get percentage of selected price from total flight price
		const limit = parseFloat(((+priceToConvert / cashToBePaid) * 100).toFixed(0));

		if (limit) {
			// get applicable conversion rate
			let currencyRatio = 0;
			const conversionRate = this.conversionRates;
			if (conversionRate.length && limit >= conversionRate[0].minLimit ) {
				conversionRate.forEach(rate => {
					if (limit >= rate.minLimit) {
						currencyRatio = rate.currencyRatio;
					}
				});

				if (!currencyRatio) {
					currencyRatio = conversionRate[0].currencyRatio;
				}
			}

			if (currencyRatio) {
				// convert selected price based on currency ratio
				const priceToDeduct = cashToBePaid * (limit / 100) * currencyRatio;
				newCashTobePaid = parseFloat((cashToBePaid - priceToDeduct).toFixed(2));
			}
		}

		return newCashTobePaid;
	}

	INDRA_updateMiles(cash: number) {
		return this.api.INDRA_post<any>(`${URL_MILES_USE_MILES}${cash}`, {});
	}

	INDRA_addMilesDiscount() {
		return this.api.INDRA_post<any>(`${URL_ADD_MILES_DISCOUNT}`, {});
	}

	INDRA_removeMilesDiscount() {
		return this.api.INDRA_post<any>(`${URL_REMOVE_MILES_DISCOUNT}`, {});
	}

  INDRA_setTriggerUseMiles(value: boolean) {
    this._triggerUseMiles.next(value);
  }
}
